import React, { useState, useEffect } from 'react';
import { FaBirthdayCake, FaTimes } from 'react-icons/fa';

const AgeVerification: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    const verified = localStorage.getItem('ageVerified');
    if (!verified) {
      setIsVisible(true);
    } else {
      setIsVerified(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setIsVerified(true);
    setIsVisible(false);
  };

  const handleDecline = () => {
    window.location.href = 'https://www.gambleaware.org';
  };

  if (!isVisible || isVerified) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/95 backdrop-blur-sm">
      <div className="glass rounded-2xl p-8 max-w-md mx-4 animate-slide-up">
        <div className="text-center mb-6">
          <FaBirthdayCake className="text-6xl text-accent-primary mx-auto mb-4 animate-float" />
          <h2 className="text-3xl font-bold mb-2">Age Verification Required</h2>
          <p className="text-gray-400">You must be 18 or older to access this site</p>
        </div>
        <div className="space-y-4">
          <button
            onClick={handleConfirm}
            className="w-full bg-gradient-to-r from-accent-primary to-accent-secondary text-white font-bold py-4 px-6 rounded-lg hover:shadow-lg hover:shadow-accent-primary/50 transition-all duration-300 transform hover:scale-105"
          >
            I am 18 or older
          </button>
          <button
            onClick={handleDecline}
            className="w-full bg-dark-card text-gray-400 font-semibold py-4 px-6 rounded-lg hover:bg-dark-hover transition-colors"
          >
            I am under 18
          </button>
        </div>
        <p className="text-xs text-gray-500 text-center mt-6">
          By entering this site, you agree to our Terms & Conditions and Privacy Policy.
          Please gamble responsibly.
        </p>
      </div>
    </div>
  );
};

export default AgeVerification;

